// eslint-disable-next-line react/prop-types
const CustomHelperTextComponent = ({ errorText }) => {
	return errorText ? (
		<div className="details" style={{ paddingLeft: "12.7" }}>
			<span className="select-validation-text">{errorText}</span>
		</div>
	) : null;
};

export default CustomHelperTextComponent;
